import { WabunkaExperienceEventFirstAvailableDateResponse } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_event';

import { useFetchFromPublicWabunkaApiKey, type UseFetchFromPublicWabunkaApi } from '@/injectionKeys';

/**
 * 体験の直近予約可能日を取得する Composable
 * CSR のみで取得し、カレンダーの初期表示月の決定に使用する
 */
export const useFirstAvailableDateQuery = (idOrSlug: Ref<string>) => {
  const useFetchFromPublicWabunkaApi = inject(useFetchFromPublicWabunkaApiKey) as UseFetchFromPublicWabunkaApi;
  const path = computed(() => `/experiences/${encodeURIComponent(idOrSlug.value)}/experienceEvents/firstAvailableDate`);

  const { data, status } = useFetchFromPublicWabunkaApi({
    path,
    options: { server: false, watch: [idOrSlug] },
    converter: WabunkaExperienceEventFirstAvailableDateResponse.fromJSON,
  });

  const firstAvailableDate = computed(() => data.value?.firstAvailableDate ?? '');

  return { firstAvailableDate, status };
};
